import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-mail-opened-icon',
  templateUrl: './communication-mail-opened.component.html'
})
export class CommunicationMailOpenedComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
